import { FormControlBase, FormControlTypeEnum } from '../models';

export class FormControlGps extends FormControlBase<string> {
	public controlType = FormControlTypeEnum.Gps;
}
